import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { ShieldCheck, AlertTriangle, AlertOctagon } from 'lucide-react';

const config = {
  green: {
    bg: 'bg-risk-greenbg', text: 'text-risk-green', border: 'border-risk-green/30',
    Icon: ShieldCheck, key: 'risk_green',
  },
  yellow: {
    bg: 'bg-risk-yellowbg', text: 'text-risk-yellow', border: 'border-risk-yellow/40',
    Icon: AlertTriangle, key: 'risk_yellow',
  },
  red: {
    bg: 'bg-risk-redbg', text: 'text-risk-red', border: 'border-risk-red/40',
    Icon: AlertOctagon, key: 'risk_red',
  },
};

export default function RiskBadge({ level = 'green', size = 'md' }) {
  const { t } = useLanguage();
  const c = config[level] || config.green;
  const Icon = c.Icon;
  const sizing = size === 'lg' ? 'px-4 py-2 text-sm' : 'px-3 py-1 text-xs';
  return (
    <span
      data-testid={`risk-badge-${level}`}
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold border ${c.bg} ${c.text} ${c.border} ${sizing}`}
    >
      <Icon size={size === 'lg' ? 16 : 14} />
      {t(c.key)}
    </span>
  );
}
